import { render, staticRenderFns } from "./KezSidebar.vue?vue&type=template&id=f2b8298e&"
import script from "./KezSidebar.vue?vue&type=script&lang=js&"
export * from "./KezSidebar.vue?vue&type=script&lang=js&"
import style0 from "./KezSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KezSidebar.vue"
export default component.exports